export default "__VITE_ASSET__f_4tde1e__"